export default __webpack_public_path__ + "static/media/Trackertools-screenshot-desktop.9d0d8302.png";